import { useEffect } from 'react';

export default function useWheelZoom(containerRef, onZoomIn, onZoomOut) {
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleWheel = (event) => {
            if (event.ctrlKey) {
                event.preventDefault();
                if (event.deltaY < 0) {
                    onZoomIn();
                } else {
                    onZoomOut();
                }
            }
        };

        container.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            container.removeEventListener('wheel', handleWheel);
        };
    }, [containerRef, onZoomIn, onZoomOut]);
}
